import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { storage } from './config';

export const uploadLessonResource = async (userId, lessonId, file) => {
  try {
    // Create a unique filename
    const timestamp = Date.now();
    const fileName = `${timestamp}_${file.name}`;
    const filePath = `users/${userId}/lessons/${lessonId}/resources/${fileName}`;

    // Create a reference to the file location
    const storageRef = ref(storage, filePath);

    // Upload the file
    await uploadBytes(storageRef, file);

    // Get the download URL
    const downloadURL = await getDownloadURL(storageRef);

    return {
      success: true,
      url: downloadURL,
      fileName: file.name,
      filePath
    };
  } catch (error) {
    console.error('Error uploading file:', error);
    return { success: false, error };
  }
};

export const uploadAssignmentResource = async (userId, assignmentId, file) => {
  try {
    // Create a unique filename
    const timestamp = Date.now();
    const fileName = `${timestamp}_${file.name}`;
    const filePath = `users/${userId}/assignments/${assignmentId}/resources/${fileName}`;

    // Create a reference to the file location
    const storageRef = ref(storage, filePath);

    // Upload the file
    await uploadBytes(storageRef, file);

    // Get the download URL
    const downloadURL = await getDownloadURL(storageRef);

    return {
      success: true,
      url: downloadURL,
      fileName: file.name,
      filePath
    };
  } catch (error) {
    console.error('Error uploading file:', error);
    return { success: false, error };
  }
};

export const deleteResourceFile = async (filePath) => {
  try {
    const storageRef = ref(storage, filePath);
    await deleteObject(storageRef);
    return { success: true };
  } catch (error) {
    console.error('Error deleting file:', error);
    return { success: false, error };
  }
};

export const uploadTeamDocument = async (file, uploadedBy) => {
  try {
    // Create a unique filename
    const timestamp = Date.now();
    const fileName = `${timestamp}_${file.name}`;
    const filePath = `team/documents/${fileName}`;

    // Create a reference to the file location
    const storageRef = ref(storage, filePath);

    // Upload the file
    await uploadBytes(storageRef, file);

    // Get the download URL
    const downloadURL = await getDownloadURL(storageRef);

    return {
      success: true,
      url: downloadURL,
      fileName: file.name,
      filePath,
      uploadedBy
    };
  } catch (error) {
    console.error('Error uploading team document:', error);
    return { success: false, error };
  }
};
